/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-05 17:22:48
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-05 17:32:47
 */

import Certificates from "./certificates";
import { IYxInputPropTypes } from "../IpropType/basePropType";
import PropTypes from "prop-types";

//类型约束
Certificates.propTypes = {
  ...IYxInputPropTypes,
  //证件类型:identity-身份passport-护照military-军官证police-警官证
  type: PropTypes.oneOf(["identity", "passport", "military", "police"]),
};
//默认参数
Certificates.defaultProps = {
  type: "identity", //证件类型 identity/passport/military/police  身份证/护照/军官证/警官证
  inputParam: {}, //存给input的参数
  value: "",
  children: "",
  // 子节点
  rules: {},
  styleParam: {
    width: "sm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
};

export default Certificates;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Certificates/index.js